import api from '@pray/shared/utils/api';
import type { SuccessResponse } from '@pray/shared/utils/api/types/response';

type GetChatbotPromptParams = {
  handler: string;
  type: string;
};

export type ChatbotPromptResource = {
  handlerType: string;
  promptType: string;
  text: string | null;
  /** Added by the server in the AI settings release; absent on older servers. */
  updated_at?: string | null;
  updated_by_email?: string | null;
};

export async function getChatbotPrompt({ handler, type }: GetChatbotPromptParams): Promise<ChatbotPromptResource> {
  if (!handler) throw Error('Handler is required');
  if (!type) throw Error('Type is required');

  const url = `/web/studio/conversations/settings/prompts`;
  const response = await api.executeGetRequest<SuccessResponse<ChatbotPromptResource>>(url, { handler, type });

  return response.data.data[0].resource;
}
